import { useState } from "react";
import DashboardLayout from "../../../Layout/DashboardLayout";
import EmailConfigIndex from "./EmailConfig";
import CredentialsConfig from "./CredentialsConfig";
import MicrosoftSSOConfig from "./MicrosoftSSOConfig";


const TABS = [
  { key: "credentials", label: "Credentials",         icon: "key"      },
  { key: "email",       label: "Email Configuration", icon: "mail"     },
  { key: "sso",         label: "Microsoft SSO",       icon: "security" },
];

export default function GeneralConfigIndex({ embedded = false } = {}) {
  const [activeTab, setActiveTab] = useState("credentials");

  const inner = (
    <>
      <div className="px-8 py-8 bg-[#f7fafa] min-h-screen text-[#181c1d]">

        

        
        {/* ── Tab bar ── */}
        <div className="flex gap-1 bg-white p-1.5 rounded-2xl shadow-[0px_20px_40px_rgba(24,28,29,0.06)] border border-white/40 mb-8 w-fit">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-bold transition-all
                ${activeTab === tab.key
                  ? "bg-[#08757c] text-white shadow-md"
                  : "text-[#3e494a] hover:bg-[#f1f4f4]"}`}
            >
              <span className="material-symbols-outlined text-[18px]">{tab.icon}</span>
              {tab.label}
            </button>
          ))}
        </div>

        {/* ── Tab content — embedded skips DashboardLayout + breadcrumb ── */}
        {activeTab === "credentials" && <CredentialsConfig  embedded />}
        {activeTab === "email"       && <EmailConfigIndex   embedded />}
        {activeTab === "sso"         && <MicrosoftSSOConfig embedded />}

      </div>
    </>
  );
  return embedded ? inner : <DashboardLayout>{inner}</DashboardLayout>;
}

